import {
  Divider as MuiDivider,
  DividerProps,
  Box,
  styled,
  Typography,
  BoxProps,
} from "@mui/material";
import { theme } from "theme";

export const HeaderDivider = ({
  text,
  ...props
}: DividerProps & { text?: string }) => (
  <StyledHeaderDivider textAlign="left" {...props}>
    <Typography variant="h4">{text}</Typography>
  </StyledHeaderDivider>
);

export const DashedDivider = ({
  color = "teal.dark",
  dashLength = 4,
  gap = 6,
  sx,
  ...props
}: BoxProps & { color?: string; dashLength?: number; gap?: number }) => {
  const resolvedColor = resolveColor(color);

  return (
    <Box
      {...props}
      sx={{
        height: "1px",
        width: "100%",
        backgroundImage: `repeating-linear-gradient(
          to right,
          ${resolvedColor},
          ${resolvedColor} ${dashLength}px,
          transparent ${dashLength}px,
          transparent ${dashLength + gap}px
        )`,
        ...sx,
      }}
    />
  );
};

const resolveColor = (colorKey: string) => {
  const [mainKey, subKey] = colorKey.split(".");

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const palette = theme.palette as any;
  return palette?.[mainKey]?.[subKey] || palette?.[colorKey] || colorKey;
};

const StyledHeaderDivider = styled(MuiDivider)(({ theme }) => ({
  "&::before": {
    display: "none",
  },
  "&::before, &::after": {
    borderColor: theme.palette.grey[400],
  },
  "& > .MuiDivider-wrapper": {
    paddingLeft: 0,
    paddingRight: theme.spacing(2),
  },
  borderColor: theme.palette.teal.dark,
  textAlign: "left",
}));
